import { Icon } from '@iconify/react';

const Hero = () => {
  const stats = [
    { value: '1,240', label: 'Total Karyawan', change: '+12%', changeColor: 'text-emerald-400' },
    { value: '1,092', label: 'Karyawan Aktif', change: '+8%', changeColor: 'text-emerald-400' },
    { value: '3,480', label: 'Total Kandidat', change: '+24%', changeColor: 'text-emerald-400' },
    { value: '28', label: 'Posisi Terbuka', change: '5 urgent', changeColor: 'text-amber-400' },
  ];

  return (
    <section
      id="beranda"
      className="gradient-hero relative overflow-hidden pt-32 pb-20 md:pt-40 md:pb-32"
    >
      {/* ===== BACKGROUND DECORATIONS ===== */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-white/5 rounded-full"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] border border-white/5 rounded-full"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">

          {/* ===== LEFT CONTENT ===== */}
          <div className="animate-fade-in">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-6">
              <Icon icon="mdi:star" className="text-amber-400 text-sm" />
              <span className="text-xs font-medium text-white/90">Platform HR #1 di Indonesia</span>
            </div>

            {/* Heading */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              Kelola Rekrutmen Lebih{' '}
              <span className="text-zentra-200">Cerdas</span>
              , Cepat & Terukur
            </h1>

            {/* Description */}
            <p className="text-lg text-white/70 mb-8 max-w-lg leading-relaxed">
              Satu platform untuk seluruh proses rekrutmen & manajemen karyawan.
              Otomatisasi, AI screening, dan analytics dalam satu dashboard.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 mb-10">
              <button className="bg-white text-zentra-700 text-sm font-semibold px-8 py-3.5 rounded-xl hover:bg-gray-50 transition-all hover:shadow-xl hover:shadow-black/10">
                Mulai Gratis{' '}
                <Icon icon="mdi:arrow-right" className="inline-block ml-1 text-sm" />
              </button>
              <button className="bg-white/10 backdrop-blur-sm border border-white/20 text-white text-sm font-semibold px-8 py-3.5 rounded-xl hover:bg-white/20 transition-all">
                <Icon icon="mdi:play-circle-outline" className="inline-block mr-1 text-base" />
                Lihat Demo
              </button>
            </div>

            {/* Social Proof */}
            <div className="flex items-center gap-6">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) => (
                  <img
                    key={i}
                    src={`https://picsum.photos/seed/avatar${i}/40/40.jpg`}
                    className="w-8 h-8 rounded-full border-2 border-white/30 object-cover"
                    alt={`User ${i}`}
                  />
                ))}
              </div>
              <div>
                <p className="text-sm font-semibold text-white">2,000+ Perusahaan</p>
                <p className="text-xs text-white/60">sudah mempercayai Zentra</p>
              </div>
            </div>
          </div>

          {/* ===== RIGHT CONTENT - DASHBOARD PREVIEW ===== */}
          <div className="float-anim hidden lg:block">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 shadow-2xl">
              {/* Dashboard Header */}
              <div className="flex items-center gap-2 mb-5">
                <div className="w-3 h-3 rounded-full bg-red-400"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                <div className="w-3 h-3 rounded-full bg-green-400"></div>
                <span className="ml-3 text-xs text-white/50">Zentra Dashboard</span>
              </div>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 gap-3 mb-4">
                {stats.map((stat, index) => (
                  <div key={index} className="stat-card rounded-xl p-4">
                    <p className="text-xs text-white/50 mb-1">{stat.label}</p>
                    <p className="text-2xl font-bold text-white">{stat.value}</p>
                    <p className={`text-xs ${stat.changeColor} mt-1`}>
                      ↑ {stat.change}
                    </p>
                  </div>
                ))}
              </div>

              {/* Chart */}
              <div className="stat-card rounded-xl p-4">
                <div className="flex justify-between items-center mb-3">
                  <p className="text-xs font-medium text-white/70">Rekrutmen Overview</p>
                  <p className="text-xs text-white/40">6 bulan terakhir</p>
                </div>
                <svg className="w-full h-20" viewBox="0 0 300 80">
                  <defs>
                    <linearGradient id="chartGrad" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#A78BFA" stopOpacity="0.3" />
                      <stop offset="100%" stopColor="#A78BFA" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                  <path
                    d="M0,60 C30,55 60,40 90,35 C120,30 150,45 180,25 C210,15 240,20 270,10 L300,8 L300,80 L0,80 Z"
                    fill="url(#chartGrad)"
                  />
                  <path
                    d="M0,60 C30,55 60,40 90,35 C120,30 150,45 180,25 C210,15 240,20 270,10 L300,8"
                    fill="none"
                    stroke="#A78BFA"
                    strokeWidth="2.5"
                  />
                  <circle cx="300" cy="8" r="4" fill="#A78BFA" />
                </svg>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
